export const convertTextToId = (str) => {
  if (!str) return;
  return String(str)?.toLocaleLowerCase()?.replace(/[^a-zA-Z0-9]/g, "")?.trim()?.replaceAll(' ', '_');
}
